(()=>{
  const closeDesktopGroup=button=>{
    const id=button.getAttribute('aria-controls')
    const panel=id?document.getElementById(id):null
    button.setAttribute('aria-expanded','false')
    if(panel)panel.hidden=true
    button.closest('[data-aph-nav-group]')?.classList.remove('is-open')
  }

  const openDesktopGroup=button=>{
    const id=button.getAttribute('aria-controls')
    const panel=id?document.getElementById(id):null
    button.setAttribute('aria-expanded','true')
    if(panel)panel.hidden=false
    button.closest('[data-aph-nav-group]')?.classList.add('is-open')
  }

  const closeDesktopGroups=(dropdown,except=null)=>{
    dropdown?.querySelectorAll('[data-aph-nav-group-toggle]').forEach(button=>{
      if(button!==except)closeDesktopGroup(button)
    })
  }

  const bindDesktopDropdown=dropdown=>{
    if(!dropdown||dropdown.dataset.aphAccordionBound==='true')return

    dropdown.dataset.aphAccordionBound='true'

    dropdown.querySelectorAll('[data-aph-nav-group-toggle]').forEach(button=>{
      button.addEventListener('click',event=>{
        event.preventDefault()
        event.stopPropagation()

        const isOpen=button.getAttribute('aria-expanded')==='true'

        closeDesktopGroups(dropdown,button)

        if(isOpen)closeDesktopGroup(button)
        else openDesktopGroup(button)
      })
    })
  }

  const closeMobileGroup=button=>{
    const id=button.getAttribute('aria-controls')
    const panel=id?document.getElementById(id):null

    button.setAttribute('aria-expanded','false')

    if(panel)panel.hidden=true

    button.closest('[data-aph-mobile-group]')?.classList.remove('is-open')
  }

  const openMobileGroup=button=>{
    const id=button.getAttribute('aria-controls')
    const panel=id?document.getElementById(id):null

    button.setAttribute('aria-expanded','true')

    if(panel)panel.hidden=false

    button.closest('[data-aph-mobile-group]')?.classList.add('is-open')
  }

  const closeMobileGroups=(submenu,except=null)=>{
    submenu?.querySelectorAll('[data-aph-mobile-group-toggle]').forEach(button=>{
      if(button!==except)closeMobileGroup(button)
    })
  }

  const bindMobileSubmenu=submenu=>{
    if(!submenu||submenu.dataset.aphMobileAccordionBound==='true')return

    submenu.dataset.aphMobileAccordionBound='true'

    submenu.querySelectorAll('[data-aph-mobile-group-toggle]').forEach(button=>{
      button.addEventListener('click',event=>{
        event.preventDefault()
        event.stopPropagation()

        const isOpen=button.getAttribute('aria-expanded')==='true'

        closeMobileGroups(submenu,button)

        if(isOpen)closeMobileGroup(button)
        else openMobileGroup(button)
      })
    })
  }

  const resetMobileMenu=dialog=>{
    dialog?.querySelectorAll('[data-aph-mobile-group-toggle]').forEach(closeMobileGroup)

    dialog?.querySelectorAll('[data-aph-mobile-submenu-toggle]').forEach(button=>{
      button.setAttribute('aria-expanded','false')

      const item=button.closest('.aph-mobile-nav__item')
      const submenu=item?.querySelector(':scope > .aph-mobile-nav__submenu')

      if(submenu)submenu.hidden=true
    })
  }

  const init=(scope=document)=>{
    scope.querySelectorAll?.('[data-aph-nav-accordion]').forEach(bindDesktopDropdown)
    scope.querySelectorAll?.('[data-aph-mobile-submenu]').forEach(bindMobileSubmenu)

    scope.querySelectorAll?.('[data-aph-mobile-dialog]').forEach(dialog=>{
      if(dialog.dataset.aphAccordionResetBound==='true')return

      dialog.dataset.aphAccordionResetBound='true'

      dialog.addEventListener('close',()=>{
        resetMobileMenu(dialog)
      })
    })
  }

  document.addEventListener('click',event=>{
    const topToggle=event.target.closest?.('[data-aph-nav-toggle]')

    if(topToggle){
      requestAnimationFrame(()=>{
        if(topToggle.getAttribute('aria-expanded')==='false'){
          closeDesktopGroups(
            topToggle
              .closest('.aph-nav__item')
              ?.querySelector('[data-aph-nav-accordion]')
          )
        }
      })

      return
    }

    const mobileTopToggle=event.target.closest?.('[data-aph-mobile-submenu-toggle]')

    if(mobileTopToggle){
      requestAnimationFrame(()=>{
        const item=mobileTopToggle.closest('.aph-mobile-nav__item')
        const submenu=item?.querySelector(':scope > .aph-mobile-nav__submenu')

        if(
          mobileTopToggle.getAttribute('aria-expanded')==='false' &&
          submenu
        ){
          closeMobileGroups(submenu)
        }
      })

      return
    }

    if(event.target.closest?.('.aph-nav__item'))return

    document.querySelectorAll('[data-aph-nav-accordion]').forEach(dropdown=>{
      closeDesktopGroups(dropdown)
    })
  })

  document.addEventListener('keydown',event=>{
    if(event.key!=='Escape')return

    document.querySelectorAll('[data-aph-nav-accordion]').forEach(dropdown=>{
      closeDesktopGroups(dropdown)
    })

    document.querySelectorAll('[data-aph-mobile-submenu]').forEach(submenu=>{
      closeMobileGroups(submenu)
    })
  })

  document.addEventListener('shopify:section:load',event=>{
    init(event.target)
  })

  window.AphHeaderAccordion={init}

  if(document.readyState==='loading'){
    document.addEventListener(
      'DOMContentLoaded',
      ()=>init(document),
      {once:true}
    )
  }else{
    init(document)
  }
})()